<template>
  <div>
    <el-form :model="searchForm" class="search-form" ref="searchFormRef">
      <el-form-item label="模板名称" prop="productName">
        <el-input
          style="width:200px"
          :maxlength="255"
          v-model="searchForm.name"
          placeholder="模板名称"
        />
      </el-form-item>
      <el-form-item
        label="模板ID"
        prop="productId"
      >
        <el-input
          style="width:170px"
          :maxlength="255"
          v-model="searchForm.templateCode"
          placeholder="模板ID"
        />
      </el-form-item>
      <el-form-item>
        <!-- 操作按钮 -->
        <el-button type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="handelAdd(1)">创建模板</el-button>
    <my-table
      :indexType="true"
      :tableData="table.tableData"
      :headerList="table.headerList"
      :loading="table.loading"
      :page-size="params.pageSize"
      :currentPage="params.pageNo"
      :total="table.total"
      @currentPage-change="handlePageChange"
      @sizePage-change="handleSizeChange"
    >
      <!-- 自定义内容 -->
      <template v-slot:operation="{ data }">
        <el-link type="primary" @click="handelAdd(2,data)">详情</el-link>
      </template>
    </my-table>

    <couponsTemplateCreat
      ref="couponsTemplateCreatRef" :couponPlatformType="couponPlatformType"
      @refresh="refresh"
    ></couponsTemplateCreat>
  </div>
</template>

<script>
import myTable from '@/components/my-table.vue'
import couponsTemplateCreat from '@/components/couponsTemplateCreat.vue'
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";

export default {
  name: 'CouponsTemplateList',
  components:{
    myTable,
    couponsTemplateCreat,
  },
  props: {
    couponPlatformType:'',
  },
  data() {
    return {
      searchForm:{
        name: '', // 模版名称
        templateCode: '', // 模板ID
      },
      params:{
        pageNo: 1,
        pageSize: 10,
        name:'', // 模版名称
        templateCode:'', //模板编码
      },
      table:{
        loading: false,
        total: 0,
        tableData: [],
        headerList:[
          {
            prop: 'name',
            label: '模板名称',
            width: '180',
          },
          {
            prop: 'typeStr',
            label: '模板类型',
            width: '180',
          },
          {
            prop: 'createTime',
            label: '创建时间',
            width: '180',
            // customRender:'customName'
          },
          {
            prop: 'templateCode',
            label: '模板ID',
            width: '180',
          },
          {
            prop: 'operation',
            label: '操作',
            width: '120',
            customRender: 'operation',
            fixed: 'right', //是否固定列
          }
        ],
      }
    }
  },
  mounted() {
    console.log('mounted==couponsTemplateList');
    this.getList()
  },
  methods: {
    // 表单搜素
    onFormSearch() {
      debounce(
        () => {
          this.$refs['searchFormRef'].validate((valid) => {
            if (valid) {
              this.params.pageNo = 1;
              this.getList();
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        500,
        true
      );
    },
    onFormReset() {
      debounce(()=> {
        this.searchForm = {
          name: '', // 模版名称
          templateCode: '', // 模板ID
        }
        this.$refs['searchFormRef'].resetFields();
        this.getList()
      },1000,true)
    },
    async getList() {
      this.table.loading = true;
      const res = await MiniModel.couTemplatePage({
        appKey: localStorage.getItem("appKeyMini"),
        couponPlatformType: this.couponPlatformType,
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
        ...this.searchForm,
      })
      this.table.loading = false;
      console.log(res,'res==couTemplatePage')
      if(res.data.code !== 200) {
        this.$message.error(res.data.message)
        return
      }
      this.table.tableData = res.data.data.list
      this.table.total = res.data.data.total;
      this.params.pageNo = res.data.data.pageNo
    },
    handelAdd(type,row) {
      console.log('创建模板');
      this.$refs.couponsTemplateCreatRef.handelOpen(type,row)
    },
    refresh() {
      console.log('刷新列表111');
      this.getList()
    },
    // 分页
    handlePageChange(val) {
      this.params.pageNo = val
      this.getList()
    },
    // 每页显示条数
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/couponsTemplateList.vue